/// <amd-module name="VSS/Redux/Modules/ContentViewObserver/ContentViewObserverModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { IContentViewAwareState, IContentViewObserverModuleArgs } from "./ContentViewObserverContracts";
import { filterObserverReducer } from "./ContentViewObserverReducer";
import { filterObserverSaga } from "./ContentViewObserverSaga";

export function getContentViewObserverModule(params: IContentViewObserverModuleArgs): ISagaModule<IContentViewAwareState> {
    return {
        id: "content-view",
        reducerMap: {
            contentViewObserver: filterObserverReducer
        },
        sagas: [
            {
                saga: filterObserverSaga,
                argument: params
            }
        ]
    };
}
